module.exports = "/images/vendor/flag-icon-css/flags/1x1/kw.svg?33b3292eb3089a10a5cb93cfda9efda2";